<template>
    <div
        class="footer-wrapper"
    >
        <div class="landing-page-footer container">
           <span
               v-if="notice"
               class="notice"
           >
               {{ notice }}
           </span>
            <template
                v-for="(item,index) in links"
            >
                <b-link
                    :key="index"
                    :href="item.url"
                    target="_blank"
                    class="link"
                >
                    {{ item.title }}
                </b-link>
                <span
                    v-if="links.length > 1 && index < links.length-1"
                    class="delimiter text-gray-700"
                >
                    |
                </span>
            </template>
            <br />

            <div
                v-if="isMobile"
                class="mb-5 mt-3"
            >
                <b-row>
                    <b-col cols="12">
                        <div class="legal-links">
                            <b-link
                                :href="termsOfUse"
                                target="_blank"
                            >
                                Terms of Use
                            </b-link>
                            |
                            <b-link
                                :href="privacyPolicy"
                                target="_blank"
                            >
                                Privacy Policy
                            </b-link>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <div v-else>
                <div class="d-inline-flex text-center">
                    <div class="legal-links">
                        <b-link
                            :href="termsOfUse"
                            target="_blank"
                        >
                            Terms of Use
                        </b-link>
                        |
                        <b-link
                            :href="privacyPolicyUrl"
                            target="_blank"
                        >
                            Privacy Policy
                        </b-link>
                    </div>
                </div>
                <br />
                <b-img
                    fluid
                    width="72"
                    :src="require('../../../../assets/images/equal-housing.png')"
                    class="equal-housing"
                />
            </div>
        </div>
    </div>
</template>

<script>
import './LandingPageFooter.scss';
import {termsOfUse} from "@milestoneslabs/milestones-ui-kit/src/helpers/externalLinks";
import {MILESTONES_LOGO} from "../../../helpers/images";
import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
import PrivacyPolicyUrlMixin from "../../../Mixins/PrivacyPolicyUrlMixin";

export default {
    name: "LandingPageFooter",
    mixins: [
        IsMobileMixin,
        PrivacyPolicyUrlMixin,
    ],

    props: {
        notice: {
            type: String,
            default: ''
        },
        links: {
            type: Array,
            default: () => {
                return [];
            }
        },
    },
    data() {
        return {
            termsOfUse,
            MILESTONES_LOGO,
        };
    },
    computed: {
        year() {
            return (new Date).getFullYear();
        },
    }
};
</script>
